<template>
  <!-- <div class="fx_menu_box"> -->
  <ul class="fx_menu">
    <div class="fx_menu_left" ref="menu_left">
      <div class="site-title" :style="{ background: `url(${this.$store.state.core.logoUrl}) no-repeat left center` }">
        <!-- <span class="system_name">{{ isSystemName ? title : "" }}</span> -->
        <span class="system_name">{{ title }}</span>
      </div>
    </div>

    <!-- 一级 -->
    <div class="fx_menu_right" ref="fxmenu_right">
      <li v-if="item.children == undefined" :title="item.text.length > 7 ? item.text : null" style="padding: 0 14px" class="fx_menu_item" :class="{ fx_activeName: activeName == item.name }" v-for="(item, index) in navs" :key="index" @click="go($event,item.name)">
        <span class="fx_menu_item_text" style="position: relative;display: flex;justify-content: center;align-items: center;">
          <svg-icon v-if="item.svg" :iconClass="item.svg" :className="item.svg" style="width:22px;height:22px"></svg-icon>
          <i v-else :class="item.icon" class="fa-lg" style="margin-right: 5px"></i>
          <!-- <i v-else :class="item.icon === undefined || item.icon == 'undefined' ? 'fa fa-ravelry ' : item.icon" class="fa-lg" style="margin-right: 5px"></i> -->
          <Badge class="" :count="$store.state.notify.moduleNoticeNum[item.name]">
            <span>{{ item.text }}</span>
          </Badge>
        </span>
      </li>
      <!-- 一级下拉 -->
      <li v-else @mouseenter="getDistance(`menu-submenu-${index}`, item)" :title="item.text.length > 7 ? item.text : null" :ref="`menu-submenu-${index}`" class="fx_menu-submenu" style="padding: 5px 27px 5px 14px">
        <div class="fx_menu-submenu-title submenu-title-flex">
          <!-- {{ item.icon }} -->
          <div style=" display: flex;justify-content: center;align-items: center;" :class="{
              fx__text_primary: item.children.some((p) => p.name == activeName)
                ? true
                : item.children.some((p) => {
                    if (p.children != undefined) return p.children.some((c) => c.name == activeName);
                  })
                ? true
                : false,
            }">
            <svg-icon v-if="item.svg" :iconClass="item.svg" :className="item.svg" style="width:20px;height:22px;margin-right: 5px;"></svg-icon>
            <i v-else-if='item.icon' :class="item.icon" style="margin-right: 5px; width: 20px; text-align: center"></i>
            <div style="max-width: 116px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
              {{ item.text }}
            </div>
          </div>
          <i class="fa fa-angle-down fa-lg fx_menu-submenu_down submenu_down-absolute"></i>
        </div>
        <div class="fx_select-dropdown" :style="{ left: item.icon === undefined || item.icon == 'undefined' ?(item.text.length > 7? '4%':'-20%') : (item.text.length > 7? '8%':'0%') }">
          <!-- 二级 -->
      <li class="fx_menu_item" :title="item2.text.length > 7 ? item2.text : null" v-if="item2.children == undefined" v-for="(item2, index2) in item.children" :class="{ fx_activeName: activeName == item2.name }" :key="index2" @click="go($event,item2.name)">
        <span class="fx_menu_item_text" style="position: relative">
          <svg-icon v-if="item2.svg" :style="{'margin-left':item2.text.length>7?'0':'-25px'}" :iconClass="item2.svg" :className="item2.svg" style="width:20px;height:22px;"></svg-icon>
          <i v-else-if='item2.icon' :style="{'margin-left':item2.text.length>7?'0':'-25px'}" :class="item2.icon" style=" width: 20px; text-align: center"></i>
          {{ item2.text }} <Badge class="fx_badge" :count="$store.state.notify.moduleNoticeNum[item2.name]"></Badge>
        </span>
      </li>
      <!-- 二级下拉 -->
      <li v-else class="fx_menu-dropdown-group" :title="item2.text.length > 7 ? item2.text : null">
        <div class="fx_menu-submenu-title" style="">
          <span :class="{ fx__text_primary: item2.children.some((p) => p.name == activeName) ? true : false }">
            <svg-icon v-if="item2.svg" :style="{'margin-left':item2.text.length>4?'0':'-25px'}" :iconClass="item2.svg" :className="item2.svg" style="width:20px;height:22px;"></svg-icon>
            <i v-else-if='item2.icon' :style="{'margin-left':item2.text.length>4?'0':'-25px'}" :class="item2.icon" style=" width: 20px; text-align: center"></i>
            {{ item2.text }} <i class="fa fa-angle-right fa-lg" :class="{ changeIcon: isChange, nochangeIcon: !isChange }"></i>
          </span>
        </div>
        <div class="fx_select-dropdown-list" :style="{ left: isChange ? '-134px' : '134px', top: '-5px' }">
          <!-- 三级 -->
      <li class="fx_menu_item" v-for="(item3, index3) in item2.children" :title="item3.text.length > 7 ? item3.text : null" :key="index3" :class="{ fx_activeName: activeName == item3.name }" @click="go($event,item3.name)">
        <span class="fx_menu_item_text" style="position: relative;">
          <svg-icon v-if="item3.svg" :style="{'margin-left':item3.text.length>4?'0':'-25px'}" :iconClass="item3.svg" :className="item3.svg" style="width:20px;height:22px;"></svg-icon>
          <i v-else-if='item3.icon' :style="{'margin-left':item3.text.length>4?'0':'-25px'}" :class="item3.icon" style="width: 20px; text-align: center"></i>
          {{ item3.text }}<Badge class="fx_badge" :count="$store.state.notify.moduleNoticeNum[item3.name]"> </Badge>
        </span>
      </li>
    </div>
    </li>
    </div>
    </li>
    <!-- 全局搜索框 -->
    <core-globalsearch class="site-input" style="width: 251px"></core-globalsearch>
    <!-- 铃铛 -->
    <core-remind style="margin-right: 30px" class=" fx-line3" />
    <!-- 账号管理 -->
    <core-userprofile />
    </div>
  </ul>
  <!-- </div> -->
</template>

<script>
import sideBarItem from "./sideBarItem"

export default {
  components: { sideBarItem },
  data() {
    var navs = this.$app.menus
    return {
      navs,
      isChange: false,
      // screenWidth: Number,
      menu_RightWidth: Number,
      menu_leftWidth: Number,
      fun: null, //防抖
      isSystemName: true,
    }
  },
  watch: {
    // screenWidth: function(newVal, oldVal) {
    //   //监听窗口宽度
    //   let _this = this;
    //   if (_this.fun) {
    //     //防抖
    //     clearTimeout(_this.fun);
    //   }
    //   _this.fun = setTimeout(() => {
    //     // console.log(newVal,this.menu_RightWidth + this.menu_LefttWidth ,this.menu_LefttWidth,this.menu_RightWidth);
    //     // this.menu_RightWidth = _this.$refs['fxmenu_right'].clientWidth;
    //     // this.menu_LefttWidth = _this.$refs['menu_left'].clientWidth;
    //     if (this.menu_RightWidth + this.menu_LefttWidth + 80 >= newVal) {
    //       // this.navs = this.newNav;
    //       this.isSystemName = false;
    //     } else {
    //       this.isSystemName = true;
    //     }
    //   }, 500);
    // }
    // menu_RightWidth: function (newVal, oldVal) {
    //     console.log(newVal);
    // },
    // menu_LefttWidth: function (newVal, oldVal) {
    //     console.log(newVal);
    // },
  },
  mounted() {
    // this.screenWidth = document.body.clientWidth;
    // let _this = this;
    // _this.$nextTick(() => {
    //   this.menu_RightWidth = _this.$refs["fxmenu_right"].clientWidth;
    //   this.menu_LefttWidth = _this.$refs["menu_left"].clientWidth;
    //   // console.log(this.menu_RightWidth,this.menu_LefttWidth ,'mounted',this.$refs);
    // });
    // window.onresize = () => {
    //   //监听窗口宽度
    //   return (() => {
    //     this.screenWidth = document.body.clientWidth;
    //     this.menu_RightWidth = _this.$refs["fxmenu_right"].clientWidth;
    //     // this.menu_LefttWidth = _this.$refs['menu_left'].clientWidth;
    //   })();
    // };
  },
  computed: {
    getNum() {
      let noticeNum = this.$store.getters["notify/getRouteNum"]
      if (noticeNum) return (name) => noticeNum(name)
      else return () => 0
    },
    activeName() {
      // let a = this.$route.redirectedFrom.replace("/","")
      if (this.$route.name) return this.$route.name
      if (this.$route.redirectedFrom) return this.$route.redirectedFrom.replace("/", "")
    },
    title() {
      // return this.$store.state.core.title;
      let title = this.$store.state.core.headline || this.$app.ProjSetting.title
      return title
    },
  },
  methods: {
    getDistance(key) {
      let _this = this
      if (_this.fun) {
        //防抖
        clearTimeout(_this.fun)
      }
      _this.fun = setTimeout(() => {
        let distance = document.body.clientWidth - this.$refs[key].getBoundingClientRect().right
        if (distance < 134) {
          this.isChange = true
        } else {
          this.isChange = false
        }
      }, 400)
    },
    go($event, name) {
      if ($event.ctrlKey) {
        this.$app.routeMenuToBlank(name)
        return
      }
      // app.routeMenuToBlank
      this.$app.routeMenuTo(name)
    },
  },
}
</script>
<style lang="scss">
.top-nav {
  &.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu:hover {
    color: #4caf50;
  }
  &.ivu-menu-horizontal .ivu-menu-item-active {
    color: #4caf50;
  }
  &.ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item-selected {
    background: #4caf50 !important;
    box-shadow: 0 6px 12px 0 rgba(31, 72, 33, 0.75);
    border-radius: 4px;
    color: #fff !important;
  }

  .ivu-select-dropdown {
    padding: 0;
    margin: 0;
  }
  .ivu-menu-drop-list .ivu-menu-item span {
    padding-left: 10px;
  }
  .ivu-menu-drop-list li {
    list-style: none;
  }
  &.ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown {
    max-height: 500px;
  }
}
</style>

<style lang="scss" scoped>
// .submenu-title-flex{
//   justify-content: center;
//   align-items: center;
//   display: flex;
// }
.submenu_down-absolute {
  position: absolute;
  right: 13px;
  top: 18px;
}
.changeIcon {
  position: absolute;
  top: 12px;
  right: 119px;
  transform: rotate(180deg);
}
.nochangeIcon {
  position: absolute;
  top: 13px;
  right: 6px;
}
// // .fx_menu_box {
// //   // box-shadow: rgba(0, 0, 0, 0.1) 6px 0px 16px;
// //   // background: #e2edfb;
// //   // padding: 0px 30px;
// //   flex-basis: 70px;
// //   transition: all 0.3s;
// //   background-size: cover;
// //   z-index: 2;
// //   height: 64px;
// //   line-height: 64px;
//   .fx_menu {
//     background: none;
//     width: 100%;
//     height: 100%;
//     line-height: 38px;
//     font-size: 14px;
//     z-index: 900;
//     display: flex;
//     justify-content: space-between;
//   }
//   .fx_menu_left {
//     margin-right: 20px;
//     .site-title {
//       // color: #fff;
//       font-size: 20px;
//       font-weight: bold;
//       display: flex;
//       align-items: center;
//       max-width: 400px;
//       height: 100%;
//       background: url(/static/img/logo.png) no-repeat left center;
//       .system_name {
//         padding-left: 50px;
//         line-height: initial;
//       }
//     }
//   }
//   .fx_menu_right {
//     display: flex;
//     align-items: center;
//     .fx_activeName {
//       background: #2d8cf0;
//       border-radius: 5px;
//       color: #fff;
//     }
//     .site-input {
//       margin-right: 35px;
//     }
//     .fx_menu_item {
//       padding: 0 14px;
//       white-space: nowrap;
//       margin: 0;
//       float: left;
//       position: relative;
//       cursor: pointer;
//       z-index: 3;
//       transition: all 0.2s ease-in-out;
//       display: block;
//       outline: 0;
//       list-style: none;
//       font-size: 14px;
//       text-align: -webkit-match-parent;
//       &:hover .fx_menu_item_text {
//         color: #2d8cf0;
//       }
//       &.fx_activeName {
//         &:hover .fx_menu_item_text {
//           color: #ffffff;
//         }
//       }
//     }

//     .fx_menu-submenu {
//       padding: 0 14px;
//       white-space: nowrap;
//       margin: 0;
//       float: left;
//       position: relative;
//       cursor: pointer;
//       z-index: 3;
//       transition: all 0.2s;
//       display: block;
//       outline: 0;
//       list-style: none;
//       font-size: 14px;
//       text-align: -webkit-match-parent;
//       &:hover {
//         & .fx_menu-submenu_down {
//           transform: rotate(180deg);
//           transition-delay: 0.3s;
//           -moz-transition-delay: 0.3s; /* Firefox 4 */
//           -webkit-transition-delay: 0.3s; /* Safari 和 Chrome */
//           -o-transition-delay: 0.3s; /* Opera */
//         }
//         & .fx_select-dropdown {
//           // display: flex;
//           // justify-content: center;
//           // flex-direction: column;
//           transform: scaleY(1);
//           opacity: 1;
//           transition-delay: 0.3s;
//           -moz-transition-delay: 0.3s; /* Firefox 4 */
//           -webkit-transition-delay: 0.3s; /* Safari 和 Chrome */
//           -o-transition-delay: 0.3s; /* Opera */
//           // animation: base_show 0.3s;
//           // align-items: center;
//         }
//       }
//       // @keyframes base_show {
//       //   0% {

//       //     transform: scaleY(0.5);
//       //   }
//       //   100% {
//       //     transform: scaleY(1);
//       //   }
//       // }

//       .fx_select-dropdown {
//         position: absolute;
//         left: -6px;
//         // display: none;
//         display: flex;
//         top: 39px;
//         justify-content: center;
//         align-items: center;
//         flex-direction: column;
//         max-height: 500px;
//         transition: all 0.3s;
//         min-width: 133.889px;
//         background: #fff;
//         box-shadow: 5px 5px 3px #969696;
//         transform: scaleY(0);
//         opacity: 0;
//         // animation: base_show 0.3s;
//         transform-origin: center top;
//         border-radius: 5px;
//         .fx_menu_item {
//           width: 100%;
//           border-radius: 5px;
//           text-align: center;
//         }
//         li {
//           &.fx_activeName {
//             &:hover {
//               background: #2d8cf0;
//             }
//           }
//           &:hover {
//             background: rgb(223, 223, 223);
//             border-radius: 5px;
//           }
//         }
//       }
//       .fx_menu-submenu_down {
//         margin-left: 5px;
//         transition: all 0.3s;
//       }
//     }
//     .fx_menu-dropdown-group {
//       padding: 0 14px;
//       white-space: nowrap;
//       width: 100%;
//       margin: 0;
//       float: left;
//       position: relative;
//       cursor: pointer;
//       z-index: 3;
//       transition: all 0.2s ease-in-out;
//       display: block;
//       outline: 0;
//       list-style: none;
//       font-size: 14px;
//       text-align: -webkit-match-parent;
//       .fx_menu-submenu-title {
//         text-align: center;
//       }
//       &:hover {
//         & .fx_select-dropdown {
//           display: flex;
//         }
//         & .fx_select-dropdown-list {
//           // display: flex;
//           // justify-content: center;
//           // flex-direction: column;
//           // // animation: base_show 0.2s;
//           // align-items: center;
//           transform: scaleY(1);
//           opacity: 1;
//           transition-delay: 0.3s;
//           -moz-transition-delay: 0.3s; /* Firefox 4 */
//           -webkit-transition-delay: 0.3s; /* Safari 和 Chrome */
//           -o-transition-delay: 0.3s; /* Opera */
//         }
//       }
//       // @keyframes base_show1 {
//       //   0% {
//       //     transform: scaleY(0.5);
//       //   }
//       //   100% {
//       //     transform: scaleY(1);
//       //   }
//       // }
//       .fx_select-dropdown-list {
//         display: flex;
//         justify-content: center;
//         flex-direction: column;
//         // animation: base_show 0.2s;
//         align-items: center;
//         position: absolute;
//         left: 135px;
//         top: 0;
//         transform: scaleY(0);
//         box-shadow:5px 5px 3px #888888;
//         opacity: 0;
//         // display: none;
//         max-height: 500px;
//         transition: all 0.3s;
//         min-width: 133.889px;
//         background: #fff;
//         // animation: base_show 0.2s;
//         transform-origin: center top;
//         border-radius: 5px;
//         .fx_menu_item {
//           width: 100%;
//           border-radius: 5px;
//           text-align: center;
//         }
//         li {
//           &:hover {
//             background: rgb(223, 223, 223);
//           }
//         }
//       }
//     }
//   }
// // }
.top-nav {
  background: none;
  width: 100%;
  height: 100%;
  line-height: 38px;
  font-size: 14px;
  z-index: 900;
  display: flex;
  justify-content: space-between;
  .nav__left {
    .menu_item {
      background-color: transparent !important;
      i {
        font-size: 20px;
      }
    }
  }
  &.ivu-menu-horizontal .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #4caf50 !important;
    box-shadow: 0 6px 12px 0 rgba(31, 72, 33, 0.75);
    border-radius: 4px;
    color: #fff !important;
  }
  .nav__right {
    display: flex;
    align-items: center;
    .site-input {
      margin-right: 35px;
    }
  }
}
// .site-title {
//   // color: #fff;
//   font-size: 20px;
//   font-weight: bold;
//   display: flex;
//   align-items: center;
//   max-width: 400px;
//   height: 100%;
//   background: url(/static/img/logo.png) no-repeat left center;
//   .system_name {
//     padding-left: 50px;
//     line-height: initial;
//   }
// }

.top-menu {
  margin-right: 20px;
}
@media screen and (max-width: 1600px) {
}
@media screen and (max-width: 1200px) {
  .top-nav .item_text {
    // display: none;
  }
}
</style>
<style scoped>
.ivu-menu-horizontal ::v-deep .ivu-menu-item {
  padding: 0 14px;
  white-space: nowrap;
}
.ivu-menu-horizontal ::v-deep .ivu-menu-submenu {
  white-space: nowrap;
}
@media screen and (max-width: 1200px) {
  .top-app-header .ivu-menu-horizontal ::v-deep .ivu-menu-submenu {
    padding: 0 6px;
  }
}
.top-app-header .ivu-menu-horizontal ::v-deep .ivu-menu-submenu {
  padding: 0 14px;
}
.fx_badge {
  position: absolute;
  top: -1px;
  right: -25px;
}
.fx_badge_item {
  margin: 0 0 2px 5px;
}
</style>
<style  lang="scss">
#icon-txt {
  path[p-id="1484"] {
    // fill:red
  }
}
</style>
